<template>
  <div class="left-wrapper">
    <div class="title">监测点列表</div>
    <div class="search-box">
      <el-input placeholder="请输入搜索内容" suffix-icon="el-icon-search" v-model="searchForm.name">
      </el-input>
    </div>
    <el-row :gutter="8" class="select">
      <el-col :span="12">
        <el-select v-model="searchForm.type" placeholder="监测点类型" clearable @change="getMonitorList">
          <el-option v-for="item in mixin_MonitorTypeDicList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="12">
        <el-select v-model="searchForm.condition" placeholder="污染情况" clearable @change="getMonitorList">
          <el-option v-for="item in mixin_LandTypeDicList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="plot-list">
      <CustomTree :data="treeData" :props="{ label: 'name' }" :highlight-current="false" @node-click="treeNodeClick">
      </CustomTree>
    </div>
  </div>
</template>

<script>
import { TreeUtil, tool } from '@Util';
import CustomTree from '@/page/jiwei/components/CustomTree/CustomTree';
import * as Api from './Api';
import DicMixin from '../mixins/DicMixin';

export default {
    mixins: [DicMixin],
    data () {
        return {
            searchForm: {
                name: '',
                type: '',
                condition: '',
            },
            props: {
                onMonitorList: {
                    type: Function,
                    default: null,
                },

            },
            // 机构列表
            organList: [],
            // 监测点列表
            monitorList: [],
        };
    },
    components: {
        CustomTree,
    },
    computed: {
        treeData () {
            let organList = tool.deepCopy(this.organList);
            let monitorList = this.monitorList;

            let displayOrganList = TreeUtil.displayTree(organList);

            displayOrganList.forEach((item, index) => {
                let children = monitorList.filter((pItem) => pItem.organId === item.id);
                let obj = item;
                obj.nodeType = 'folder';
                obj.name = item.text;
                if (obj.children) {
                    obj.children = obj.children.concat(children);
                } else {
                    obj.children = children;
                }
            });

            return organList;
        },
    },
    methods: {
        treeNodeClick (data, node) {
            this.$emit('treeChildreClick', data);
        },
        // 获取机构列表
        getOrganList () {
            Api.fetchOrganTree()
                .run()
                .then((res) => {
                    this.organList = res;
                });
        },
        getMonitorList () {
            let list = [];
            let params = this.searchForm;
            Api.fetchMonitorList(params)
                .run()
                .then((res) => {
                    list = res || [];
                    this.monitorList = list;
                    if (typeof this.onMonitorList === 'function') {
                        this.onMonitorList(list);
                    }
                });
        },
        // 获取数据字典
        getDic () {
            this.mixinGetMonitorTypeDic();
        },

    },
    mounted () {
        this.getDic();
        this.getOrganList();
        this.getMonitorList();
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.left-wrapper {
  .title {
    padding-top: 11px;
    text-align: center;
    font-size: 18px;
    height: 37px;
    background-image: url(../imgs/titlebg01.png);
  }

  .search-box {
    padding: 0 16px;
    padding-top: 11px;
  }

  ::v-deep .el-input__inner {
    border-color: #1a47a4;
    background-color: transparent;
  }

  .select {
    margin-top: 11px;
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
  }

  .plot-list {
    margin-top: 11px;
    padding: 0 16px;
    height: 630px;
  }

  ::v-deep .el-select {
    width: 135px;
    border-color: #1a47a4;
    background-color: transparent;
  }

  ::v-deep .el-input__inner {
    color: #fff !important;
  }
}
</style>
